import type { AppData } from "./types";

export interface CallAppointmentDetails {
  id: string;
  customerName: string;
  serviceName: string;
  staffName: string | null;
  startsAt: string;
  endsAt: string;
  status: string;
}

export function callAppointmentDetails(
  data: AppData,
  call: AppData["conversations"][number],
): CallAppointmentDetails | null {
  if (!call.appointmentId) return null;
  const appointment = data.appointments.find((item) =>
    item.id === call.appointmentId
  );
  if (!appointment) return null;

  return {
    id: appointment.id,
    customerName: data.customers.find((item) =>
      item.id === appointment.customerId
    )?.displayName ?? call.callerDisplayName ?? "Anonim müşteri",
    serviceName: data.services.find((item) =>
      item.id === appointment.serviceId
    )?.name ?? "Hizmet bilgisi bulunamadı",
    staffName: data.staff.find((item) => item.id === appointment.staffId)
      ?.name ?? null,
    startsAt: appointment.startsAt,
    endsAt: appointment.endsAt,
    status: appointment.status,
  };
}
